'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconUnlink, iconUnlinkTag } from '@ni/nimble-components/dist/esm/icons/unlink';
import { wrap } from '../../utilities/react-wrapper';

export type { IconUnlink };
export { iconUnlinkTag };
export const NimbleIconUnlink = wrap(IconUnlink);